import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { Box, CircularProgress } from "@mui/material";
import { AuthContext } from "../../context/authContext";

const AuthRoutes = ({ children }) => {
  const { user, authBootstrapComplete } = useContext(AuthContext);
  const currentUser = user && (user?.role || (user?.roles && user?.roles[0]));

  if (!authBootstrapComplete) {
    return (
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "40vh",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return currentUser ? children : <Navigate to="/" />;
};

export default AuthRoutes;
